const setAudioBitrate = (senders, audioBitrate) => {
  const changes = senders.map((sender) => {
    const parameters = sender.getParameters();
    parameters.encodings.forEach((encoding) => {
      // eslint-disable-next-line no-param-reassign
      encoding.maxBitrate = audioBitrate;
    });
    return sender.setParameters(parameters);
  });
  return Promise.all(changes);
};

export default setAudioBitrate;
